import React from 'react'
import Layout from './Layout'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { stepTwoValidationSchema } from '../../utils/validation';
import { nextStep, setFormData } from '../../redux/slice/findJobSlice';
import Button from '../../components/general/Button';
import Input from '../../components/general/Input';
import { ArrowUpRight } from '../../components/common/Icons';

const StepTwoForm = () => {
    const dispatch = useDispatch();
    const stepTwoData = useSelector(state => state.findJob.stepTwoData);
    const { register, trigger, handleSubmit, setValue, formState: { errors, isValid } } = useForm({
        mode: "all",
        defaultValues: stepTwoData,
        resolver: yupResolver(stepTwoValidationSchema)
    });

    return (
        <div className='min-h-[60vh] !py-[50px] !pb-[70px] lg:flex lg:justify-between lg:gap-[30px]'>
            <div className='lg:w-[40%]'>
                <div>
                    <p className='text-primary-color'> 2/8 </p>
                    <h1 className="text-[1.6rem] font-semibold">
                        <span className='lg:block'> What is your hourly </span>
                        {/* <Image src={DoubleStar} alt="double-star" className="hidden lg:inline-block" /> */}
                        <span className='lg:block'>rate range?</span>
                    </h1>
                </div>

                <div className='hidden lg:block mt-[20px] text-[#2A2A2A]'>
                    <div className='mt-[20px]'>
                        <p> 4/8 </p>
                        <h1 className="text-[1.6rem] font-semibold">
                            <span> What is your main </span>
                            <span className='lg:block'>specialization?</span>
                        </h1>
                    </div>
                    <div className='mt-[20px] text-[#2A2A2A]'>
                        <p> 3/8 </p>
                        <h1 className="text-[1.6rem] font-semibold text-[#2A2A2A]">
                            <span> When did your </span>
                            <span className='lg:block'>commercial experience start?</span>
                        </h1>
                    </div>
                </div>
            </div>

            <div className='mt-[20px] lg:w-[60%]'>
                <div className='hidden lg:flex lg:justify-center gap-[20px] text-[13px] mb-[50px]'>
                    <p className='text-primary-color'> 1. Project Preferences </p>
                    <p className='text-primary-color'> 2. Specialization in stack </p>
                    <p> 3. Additional info </p>
                    <p> 4. Registration </p>
                </div>

                <div className='text-[12px] mb-[30px]'>
                    <div className='flex items-center justify-center gap-[10px] text-[#797979]'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 hidden lg:block">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>

                        <div className='text-left lg:text-center'>
                            The minimum rate is the floor, and desired rate is the target. Keep it real to get relevant offers
                        </div>
                    </div>
                    <div className='text-left lg:text-center text-[#797979]'>
                        and stay competitive. Also, there is no commission, so you get what you mention.
                    </div>
                </div>

                <div className='flex flex-col md:flex-row md:items-center md:justify-center gap-[20px]'>
                    <Input 
                        label="Minimum rate ($/hour)"
                        name="minimum_pay_range"
                        register={register}
                        error={errors.minimum_pay_range?.message}
                        placeholder="Enter minimum rate"
                    />
                    <div className='hidden md:block md:mt-[20px]'>
                        -
                    </div>
                    <Input 
                        label="Maximum rate ($/hour)"
                        name="maximum_pay_range"
                        register={register}
                        error={errors.maximum_pay_range?.message}
                        onChange={(e) => {
                            trigger("maximum_pay_range")
                            setValue("maximum_pay_range", e.target.value > 100 ? 100 : e.target.value, { shouldValidate: true })
                        }}
                        placeholder="Enter maximum rate"
                    />
                </div>
                <Button onClick={() => {
                    handleSubmit((data) => {
                        dispatch(setFormData({ formData: data }));
                        dispatch(nextStep())
                    })()
                }} disabled={!isValid} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[18px] lg:text-[20px] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]'>
                  <div className="flex items-center justify-center gap-2">
                    <span>Ok, next</span>
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </Button>
            </div>
        </div>
    )
}

export default StepTwoForm